import { Dispatch } from "redux";
import {QuickbetXCreateAction, QuickbetXCreateActionTypes} from "../../types/QuickbetX/quickbetXCreateTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const createQuicktipX = (data: any): any => {
    return async (dispatch: Dispatch<QuickbetXCreateAction>) => {
        try {
            dispatch({ type: QuickbetXCreateActionTypes.FETCH_QUICKBET_X_CREATE_DATA });
            const response = await axios({
                method: 'post',
                url: `/api/quicktipxs/create`,
                data: data,
                withCredentials: false
            });
            dispatch({ type: QuickbetXCreateActionTypes.FETCH_QUICKBET_X_CREATE_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuickbetXCreateActionTypes.FETCH_QUICKBET_X_CREATE_DATA_ERROR, payload: errorPayload });
        }
    }
}
